import { get } from "lodash";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import PanelMap from "./PanelMap.jsx";
import SegmentMessage from "../forms/messages/SegmentMessage.jsx";
import EstimatePanel from "./estimatePanel/EstimatePanel.jsx";

import { PANEL_STATES } from "../../state/reducers/projectWizard/projectWizardConstants.js";

import {
  selectProvidersList,
  selectRegionsList,
  selectZonesList,
  selectStepAvailability,
  selectEstimateAvailability
} from "../../state/reducers/projectWizard/projectWizardSelectors.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class WizardPage extends Component {
  static propTypes = {
    stepNumber: PropTypes.number.isRequired,
    config: PropTypes.object,
    violationErrors: PropTypes.object,
    limits: PropTypes.object,
    estimateMode: PropTypes.bool.isRequired,
    isLastStep: PropTypes.bool.isRequired,
    provider: PropTypes.object,
    region: PropTypes.object,
    zone: PropTypes.object,
    match: PropTypes.object.isRequired,
    formikProps: PropTypes.object.isRequired,
    panelCompleteStates: PropTypes.object.isRequired,

    providersList: PropTypes.array.isRequired,
    regionsList: PropTypes.array.isRequired,
    stepAvailability: PropTypes.object.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    estimateMode: false,
    isLastStep: false
  };

  checkDependencies(panel) {
    const { dependencies } = panel;
    const { panelCompleteStates } = this.props;

    if (!dependencies || dependencies.length < 1) return panel.view;

    let view = panel.view;

    dependencies.forEach(dependency => {
      if (panelCompleteStates[dependency.name] === true) {
        view = dependency.view;
      }
    });

    return view;
  }

  renderPanels() {
    const {
      stepNumber,
      config,
      violationErrors,
      limits,
      estimateMode,
      estimateAvailability,
      formikProps,
      provider,
      region,
      zone,
      providersList,
      regionsList,
      zonesList,
      stepAvailability
    } = this.props;

    const { steps, copyKey } = config;

    const step = steps[stepNumber];

    if (!step || !step.panels) return null;

    return step.panels.map(panel => {
      let view = this.checkDependencies(panel);

      const availability = get(stepAvailability, `[${panel.id}]`, {});
      // if not in estimate mode only available panels should be shown
      if (!estimateMode && !availability.available) {
        view = PANEL_STATES.INACTIVE;
      }
      // if in estiate mode all enabled panels should be shown (feature flagging will disable them)
      if (estimateMode && !availability.enabled) {
        view = PANEL_STATES.INACTIVE;
      }

      return (
        <Fragment key={`panel-${panel.id}-wrapper`}>
          <PanelMap
            key={`panel-${panel.id}`}
            type={panel.panelType}
            providersList={providersList}
            provider={provider}
            regionsList={regionsList}
            region={region}
            zonesList={zonesList}
            zone={zone}
            limits={get(limits, panel.id, {})}
            configCopyKey={copyKey}
            id={panel.id}
            config={config}
            configOptions={panel.options}
            availability={availability}
            view={view}
            formikProps={formikProps}
            apiErrors={violationErrors}
            onComplete={this.onStepComplete}
          />
          {step.defaultEstimatePanel !== false &&
            estimateAvailability === true && (
              <div className="docked-estimate-panel" key="estimate">
                <div className="estimate-content">
                  <EstimatePanel formikProps={formikProps} docked={true} />
                </div>
              </div>
            )}
        </Fragment>
      );
    });
  }

  renderFlagMessage = () => {
    const { estimateMode, isLastStep, copy } = this.props;

    if (!estimateMode || !isLastStep) return null;

    return (
      <SegmentMessage
        title={copy("project_wizard.creation_disabled_message.title")}
        message={copy("project_wizard.creation_disabled_message.description")}
        info={true}
      />
    );
  };

  render() {
    return (
      <Fragment>
        {this.renderPanels()}
        {this.renderFlagMessage()}
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => ({
  estimateAvailability: selectEstimateAvailability(state, props),
  providersList: selectProvidersList(state, props),
  regionsList: selectRegionsList(state, props),
  zonesList: selectZonesList(state, props),
  stepAvailability: selectStepAvailability(state, props),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(WizardPage);
